/**
 * Collection List Six Interactive Behavior
 * Handles hover-to-expand functionality that persists after unhover
 */
document.addEventListener('DOMContentLoaded', function() {
  const collectionLists = document.querySelectorAll('[data-collection-list]');
  
  collectionLists.forEach(collectionList => {
    const items = collectionList.querySelectorAll('[data-collection-item]');
    
    // Function to set active item
    function setActiveItem(activeItem) {
      // Remove active class from all items
      items.forEach(item => {
        item.classList.remove('tpt-collection-list-six_item--active');
      });
      
      // Add active class to the target item
      if (activeItem) {
        activeItem.classList.add('tpt-collection-list-six_item--active');
      }
    }
    
    // Check if we're on desktop/tablet (not mobile)
    function isDesktopOrTablet() {
      return window.matchMedia('(min-width: 768px)').matches;
    }
    
    items.forEach(item => {
      // Hover functionality for desktop and tablet only
      item.addEventListener('mouseenter', function() {
        if (isDesktopOrTablet()) {
          setActiveItem(this);
        }
      });
      
      // Click functionality for all devices (fallback and mobile)
      item.addEventListener('click', function(e) {
        // Prevent default action if clicking on a link
        if (e.target.tagName === 'A' || e.target.closest('a')) {
          return;
        }
        
        setActiveItem(this);
      });
      
      // Keyboard support for accessibility
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setActiveItem(this);
        }
      });
      
      // Make items focusable for keyboard navigation
      if (!item.hasAttribute('tabindex')) {
        item.setAttribute('tabindex', '0');
      }
    });
    
    // Handle window resize to disable hover on mobile
    window.addEventListener('resize', function() {
      // Re-evaluate hover behavior on resize
      // This ensures proper behavior when switching between desktop and mobile
    });
  });
});